<template>

  <div class="date-time">
    <div class="date mr-2">
      <date
        :value="value"
        @input="changeDate">
        </date>
    </div>
    <div class="time">
      <hour
        :value="hourMinute"
        @input="changeHour">
        </hour>
    </div>
  </div>
  
</template>

<script>
import moment from 'moment'
import Date from './Date'
import Hour from './Hour'

export default {
  name: 'DateTime',
  components: {
    Date,
    Hour
  },
  props: {
    'value': {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    hourMinute () {
      return this.value ? moment(this.value).format('HH:mm') : null
    }
  },
  methods: {
    changeHour (value) {
      if (this.value && value && value !== this.hourMinute) {
        const hoursMinute = value.split(':')
        const data = moment(this.value).hours(hoursMinute[0]).minute(hoursMinute[1]).toISOString()
        this.$emit('input', data)
      }
    },
    getReplaceDate (date) {
      if (this.value) {
        // const day = moment(date).format('D')
        // const month = moment(date).format('M')
        // const year = moment(date).format('YYYY')
        const hour = moment(date).format('H')
        const minute = moment(date).format('m')
        // return moment(this.value).day(day).month(month).year(year).toISOString()
        return moment(date).set({ hour: hour, minute: minute, second: 0, millisecond: 0 }).toISOString()
      } else {
        return moment(date).add(1, 'hour').minute(0).toISOString()
      }
    },
    changeDate (value) {
      const date = value ? this.getReplaceDate(value) : null
      this.$emit('input', date)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date-time{
  display: flex;
}
  .date-time > .date{
    flex: 3 50px;
  }
  .date-time > .time{
    flex: 1 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fields/DateTime.vue